import { defineChatPlace } from '../../chat/panel';

/**
 * The Copilot page's chat, in the narrow column on the right. Results and
 * the decisions they wait on (approving a query or a call) open in the
 * results area in the middle of the page, as they always have.
 */
export const copilotChat = defineChatPlace({
  id: 'copilot',
  place: 'docked',
  results: 'sidePane',
  approvals: 'pane',
  features: {
    sqlApproval: true,
    voiceCalls: true,
    addToDashboard: true,
    copy: true,
    contextChips: false,
  },
  welcome: {
    title: 'Data Copilot',
    subtitle: "Ask questions about your data. I'll explore the schema, write SQL, and analyze results.",
  },
  starters: [],
  placeholder: 'Ask about your data…',
  followUpPlaceholder: 'Ask a follow-up…',
});

/** On a phone the chat has the whole screen, so results and approvals sit in it. */
export const copilotChatMobile = defineChatPlace({
  ...copilotChat,
  place: 'page',
  results: 'inline',
  approvals: 'inline',
});
